<import name="Footer" from="./footer.html" />

<import name="CustomizationProvider" from="./customization" />
<template name="RichIdeasFooter">
    <div class="new-container">
        <CustomizationProvider>
            <Footer isRichIdeas={true} richIdeasBase={true}></Footer>
        </CustomizationProvider>
    </div>
</template>
